import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { Accordion } from '../../../../Accordion/Accordion';
import { AccordionItem } from '../../../../Accordion/AccordionItem';
import { AccionesConcurso } from '../../../Commons/AccionesConcurso';
import ListadoActas from '../../ListadoActas/ListadoActas';
import { ComiteTable } from '../Commons/ComiteTable/ComiteTable';
import ListadoPuestos from '../Commons/ListadoPuestos';
import TablaCronograma from '../Commons/TablaCronograma/TablaCronograma';

const SpacedContainer = styled(Container)`
  margin-bottom: 2rem;
`;
const ConcursoPublicadoCC = ({ etapa }) => {
  const { esCoordinadorConcursal } = useConcurso();
  return (
    <SpacedContainer>
      <Accordion>
        <AccordionItem title="Cronograma">
          <TablaCronograma />
        </AccordionItem>
        <AccordionItem title="Miembros Comité">
          <ComiteTable esCC={esCoordinadorConcursal} />
        </AccordionItem>
        <AccordionItem title="Listado de Actas y Denominaciones">
          <ListadoActas publicado />
        </AccordionItem>
        {etapa === 9 || (etapa === 10 && <></>)}
        {etapa === 11 && (
          <AccordionItem title="Postulaciones">
            <ListadoPuestos />
          </AccordionItem>
        )}
      </Accordion>
      <AccionesConcurso />
    </SpacedContainer>
  );
};

export default ConcursoPublicadoCC;
